/**
 * Create pagination config
 * 
 * @param {{
 *    pages: number,
 *    cur: number,
 *    delta: number,
 * }} options
 * 
 * @param {number} options.delta the number of visible page number
 *    buttons at both sides of current page
 * 
 * @returns {number[]} array of page numbers or -1 if there's a delimiter
 */
export default function paginate({ cur, pages, delta }) {
   if (pages === 1) return [1];
   delta = Math.min(delta, pages - 1);

   const center = Math.min(Math.max(cur, delta + 1), pages - delta);
   const buttons = [1];

   const left = center - delta;
   const right = center + delta;

   if (left > 2) {
      buttons.push((left === 3) ? 2 : -1);
   }

   for (let i = Math.max(left, 2); i < center; i++) {
      buttons.push(i);
   }

   if (center !== 1 && center !== pages) {
      buttons.push(center);
   }

   for (let i = center + 1; i <= Math.min(right, pages - 1); i++) {
      buttons.push(i);
   }

   if (right < pages - 1) {
      buttons.push((right === pages - 2) ? pages - 1 : -1);
   }

   buttons.push(pages);
   return buttons;
}